export default "__VITE_ASSET__CdKRAbAM__"